import { render, staticRenderFns } from "./GridProductos.vue?vue&type=template&id=babeb2b2&"
import script from "./GridProductos.vue?vue&type=script&lang=js&"
export * from "./GridProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports